export enum FeedbackType {
  ASK_QUESTION = 1,
  LEAVE_COMMENT = 2,
  REPORT_BUG = 3,
  SUGGEST_IMPROVEMENT = 4,
  GENERAL_FEEDBACK = 5,
  PRAISE = 6,
}

export enum ModuleType {
  HARBOR_BOOKING = 1,
  POI = 2,
  ROUTING = 3,
  GENERAL = 4,
}

export enum FeedbackStatus {
  PENDING = 1,
  IN_PROGRESS = 2,
  RESOLVED = 3,
  CLOSED = 4,
  REJECTED = 5,
}

export enum FeedbackJsmRoutingMode {
  AUTO = 1,
  MANUAL_REVIEW = 2,
}

export enum FeedbackDestination {
  JIRA_SERVICE_MANAGEMENT = 1,
  PRODUCTBOARD = 2,
}

export interface User {
  id: string;
  user_type: number;
  email: string;
  password: string;
  country_code: string | null;
  country_short_code: string | null;
  mobile: string | null;
  profile_picture: string | null;
  is_forgot_password_requested: boolean;
  status: number;
  role_id: string | null;
  name: string | null;
  first_name: string | null;
  last_name: string | null;
  date_of_birth: string | null;
  gender: string | null;
  last_login: string | null;
  profile_path: string | null;
  created_at: string;
  updated_at: string;
  is_deleted: boolean;
  identity_number: string | null;
  is_new_user: boolean;
  is_needs_password_changed: boolean;
  is_verified: boolean;
  has_accepted_terms: boolean;
  nationality: string | null;
  roles: {
    display_name: string;
  }[];
}

export interface FeedbackJiraInfo {
  issue_key?: string | null;
  issue_url?: string | null;
  status?: string | null;
  sync_error?: string | null;
}

export interface FeedbackResponse {
  id: string;
  user_id: string;
  user: User;
  feedback_type: FeedbackType;
  feedback_text: string;
  status: FeedbackStatus;
  jsm_routing_mode?: FeedbackJsmRoutingMode;
  admin_notes: string | null;
  module: ModuleType | null;
  media: string | null;
  jira_issue_key?: string | null;
  jira_issue_url?: string | null;
  jira_status?: string | null;
  jira_info?: FeedbackJiraInfo | null;
  routed_to?: number | null;
  routed_at?: string | null;
  created_at: string;
  updated_at: string;
  jira_sync_error?: string | null;
}

export interface FeedbackQueryParams {
  page?: number;
  limit?: number;
  search?: string;
  user_email?: string;
  feedback_type?: FeedbackType[];
  module?: ModuleType;
  status?: FeedbackStatus[];
  jsm_routing_mode?: FeedbackJsmRoutingMode[];
  start_date?: string;
  end_date?: string;
  sort_by?: string;
}

export interface FeedbackStatusUpdatePayload {
  status: FeedbackStatus;
  media?: string | null;
  admin_notes?: string | null;
}

export interface FeedbackRoutePayload {
  destination: number;
  routing_notes?: string;
  feedback_details?: FeedbackResponse;
}

export interface FeedbackJsmRoutingConfigItem {
  feedback_type: FeedbackType;
  feedback_type_label: string;
  routing_mode: FeedbackJsmRoutingMode;
  changed_by_id?: string | null;
  updated_at?: string | null;
}

export interface UpdateFeedbackJsmRoutingConfigPayload {
  rules: Array<{
    feedback_type: FeedbackType;
    routing_mode: FeedbackJsmRoutingMode;
  }>;
}
